import { HStack, Text } from '@talos/kyoko';

export const getInfoRow = (key: string, value?: string) => {
  return (
    <HStack w="100%" justifyContent="space-between" my="spacing4">
      <Text color="colorTextDefault" whiteSpace="nowrap" fontSize="fontSizeSmall">
        {key}
      </Text>
      <Text color="colorTextImportant" whiteSpace="nowrap" fontSize="fontSizeSmall">
        {value}
      </Text>
    </HStack>
  );
};
